import {
    AccessTokenSchema,
    AgentSchema,
    AgentSchemaV3,
    AttachSocialUserSchema,
    FeaturedCreatorsRequestSchema,
    FeaturedFollowersRequestSchema,
    FeaturedRookieSchema,
    FeaturesGuestsSchema,
    GenderResponseSchema,
    GenderResponseSchemaV3,
    GenderSchema,
    GuestPartialSchema,
    GuestSchema,
    GuestSchemaV3,
    HostPartialSchema,
    HostPartialSchemaV3,
    HostPathSchema,
    HostPhotos,
    HostSchema,
    HostSchemaV3,
    HostsAgentSchema,
    IdVerifiedSchema,
    IdVerifiedSchemaV3,
    LoginPayloadSchema,
    LoginSocialUserBodySchema,
    RepresentativeSchemaV3,
    RepresentedUserSchema,
    UserSchema,
    UserSchemaV3
} from '@/features/authentication/services/auth.schema.ts'
import {AppStatusesE} from '@/utilities/constants/appStatus'
import {AxiosRequestConfig} from 'axios'
import {z} from 'zod'
import {
    SignupGuestPayloadSchemaV3,
    SignupGuestValidationSchema,
    SignupGuestValidationV3Schema
} from './services/signupGuest.schema'
import {SignupPayloadSchemaV3, signupHostValidationV3} from './services/signupHost.schema'
import {
    SignUpRepresentativePayloadSchema,
    SignupRepresentativeValidationSchema
} from './services/signupRepresentative.schema'
import {AuthEmailValidationSchema} from './services/authEmail.schema'
import {UserRoleE} from '@/types'

export type HostType = z.infer<typeof HostSchema>
export type GuestType = z.infer<typeof GuestSchema>

export type HostTypeV3 = z.infer<typeof HostSchemaV3>
export type GuestTypeV3 = z.infer<typeof GuestSchemaV3>

export type RepresentativeTypeV3 = z.infer<typeof RepresentativeSchemaV3>

export type HostPartialType = z.infer<typeof HostPartialSchema>

export type HostPartialTypeV3 = z.infer<typeof HostPartialSchemaV3>

export type GuestPartialType = z.infer<typeof GuestPartialSchema>

export type User = z.infer<typeof UserSchema>

export type UserV3 = z.infer<typeof UserSchemaV3>

export type LoginPayload = z.infer<typeof LoginPayloadSchema>

export type FeaturesGuests = z.infer<typeof FeaturesGuestsSchema>

export type AuthState = {
    user: UserV3
    accessToken?: string
    accessTokenV1?: string
    isFirstLogin?: boolean
}

export type GeneralError = Error & {
    response?: {data: {message: string}; status: number}
}
export enum AlertTypeE {
    GUEST_ENTER_NEW_PAYMENT_METHOD = 'PA_LEADER_001',
    GUEST_ENTER_NEW_PAYMENT_METHOD_AMG = 'PA_LEADER_002',
    GUEST_CREDIT_CARD_PROBLEMS = 'PA_LEADER_003',
    HOST_ACCOUNT_PENDING = 'PA_ROOKIE_001',
    HOST_ACCOUNT_APPROVED = 'PA_ROOKIE_002',
    HOST_ACCOUNT_ID_VERIFICATION = 'PA_ROOKIE_003'
}
export type HostPhotosType = z.infer<typeof HostPhotos>
export type FeaturedRookieType = z.infer<typeof FeaturedRookieSchema>
export type LoginSocialUserBody = z.infer<typeof LoginSocialUserBodySchema>
export type AccessToken = z.infer<typeof AccessTokenSchema>
export enum AlertStatusE {
    DONATION_GOAL = 'donation-goal'
}
export type AlertStatus = AppStatusesE | AlertStatusE

export type SingleGenderType = z.infer<typeof GenderSchema>
export type GenderResponse = z.infer<typeof GenderResponseSchema>
export type GenderResponseV3 = z.infer<typeof GenderResponseSchemaV3>
export type SignupGuestValidation = z.infer<typeof SignupGuestValidationSchema>
export type SignupGuestValidationV3 = z.infer<typeof SignupGuestValidationV3Schema>

export type SignupGuestPayloadV3 = z.infer<typeof SignupGuestPayloadSchemaV3>

export type SignupHostValidationV3 = z.infer<typeof signupHostValidationV3>
export type SignupHostPayloadV3 = z.infer<typeof SignupPayloadSchemaV3>

export type IdVerifiedType = z.infer<typeof IdVerifiedSchema>

export type IdVerifiedTypeV3 = z.infer<typeof IdVerifiedSchemaV3>

export type SignupRepresentativeValidation = z.infer<typeof SignupRepresentativeValidationSchema>
export type SignupRepresentativePayload = z.infer<typeof SignUpRepresentativePayloadSchema>

export type UploadVideoRequest = {
    body: FormData
    options: AxiosRequestConfig
}
export type LoginSocialUserRequest = {
    type: 'facebook' | 'google'
    authResponse: LoginSocialUserBody
}
export type AttachSocialUser = z.infer<typeof AttachSocialUserSchema>

// For quick signup with email only
export type AuthEmailValidationType = z.infer<typeof AuthEmailValidationSchema>
export type AuthEmailPayload = {
    email: string
    user_role?: UserRoleE
    lang: string
    special_type?: string
}
export type AuthEmailVerifyResponseType = {
    email: string
    userRole: UserRoleE
    token: string
    special_type?: string
}

export type AgentType = z.infer<typeof AgentSchema>

export type AgentTypeV3 = z.infer<typeof AgentSchemaV3>

export type HostAgentType = z.infer<typeof HostsAgentSchema>
export type RepresentedUserType = z.infer<typeof RepresentedUserSchema>

export const enum ProgressLoadingVideoTypes {
    processing = 'processing',
    completed = 'completed',
    error = 'error',
    unknown = 'unknown'
}

export type FeaturedCreatorsRequestType = z.infer<typeof FeaturedCreatorsRequestSchema>
export type FeaturedFollowersRequestType = z.infer<typeof FeaturedFollowersRequestSchema>
export type HostPathType = z.infer<typeof HostPathSchema>
